import { Component, Input } from "@angular/core";
import { ChatMessage } from "@banta/common";
import { Shell, AppConfig } from "@tytapp/common";
import { environment } from "@tytapp/environment";
import { ReportComponent } from "../../moderation";
import { LoginComponent, UserService } from "@tytapp/user";
import { TYTBantaAuthentication } from "../tyt-banta-authentication";

@Component({
    selector: 'tyt-comments',
    styleUrls: ['./comments.component.scss'],
    templateUrl: './comments.component.html'
})
export class TYTCommentsComponent {
    constructor(
        private tytBantaAuth : TYTBantaAuthentication,
        private shell : Shell,
        private appConfig : AppConfig,
        private userService : UserService
    ) {
    }

    @Input()
    identifier : string;

    get useBanta() {
        return environment.useBanta;
    }

    showSignIn() {
        return this.shell.showDialog(LoginComponent);
    }

    editAvatar() {
        window.open(`/settings/profile`, '_blank');
    }

    async showPermissionDenied() {
        await this.userService.ready;
        if (this.userService.user.entitled) {
            alert('You cannot comment on this content with your current plan');
            window.open(`${environment.urls.accounts}/membership/change`, '_blank');
        } else {
            alert('You must be a member to comment on this content');
            window.open(environment.urls.purchase, '_blank');
        }
    }

    reportMessage(message : ChatMessage) {
        this.shell.showDialog(ReportComponent, message);
    }
}